export default function AuthBrand({ centered = false, size = 86 }) {
  return (
    <img
      src="/logo.png"
      alt="Olitask"
      style={{
        display: "block",
        height: size,
        width: "auto",
        objectFit: "contain",
        margin: centered ? "0 auto" : 0,
      }}
    />
  );
}
